/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
function t(t){return null!=t&&"type"in t&&"vector-tile"===t.type}function e(t){return null!=t&&"type"in t&&"raster-tile"===t.type}function n(t){return null!=t&&"type"in t&&"tile-texture"===t.type}function r(t){return null!=t&&"type"in t&&"image+type"===t.type}export{r as isImageWithType,e as isRasterTile,n as isTileTexture,t as isVectorTile};
